/**
 * Normalize AI webhook responses: plain objects or arrays (e.g. [{ output: "..." }]).
 * Billing may be on the root object or on body[0] after server attach (Phase 6E).
 */

function firstRecord(parsed) {
  if (parsed == null) return null;
  if (Array.isArray(parsed)) {
    const first = parsed[0];
    return first && typeof first === 'object' && !Array.isArray(first) ? first : null;
  }
  if (typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
  return null;
}

/**
 * @param {unknown} parsed
 * @returns {string}
 */
export function extractAssistantReplyText(parsed) {
  if (typeof parsed === 'string') return parsed;
  const root = firstRecord(parsed);
  if (root) {
    if (root.output != null) return String(root.output);
    if (root.reply != null) return String(root.reply);
    if (root.text != null) return String(root.text);
    if (root.final_markdown != null) return String(root.final_markdown);
    if (root.result != null) {
      if (typeof root.result === 'string') return root.result;
      return extractAssistantReplyText(root.result);
    }
  }
  try {
    return JSON.stringify(parsed, null, 2);
  } catch {
    return String(parsed);
  }
}

/**
 * @param {unknown} parsed
 * @param {object|null} headerBillingUi
 * @returns {object|null}
 */
export function extractWebhookBilling(parsed, headerBillingUi) {
  if (parsed && typeof parsed === 'object') {
    if (!Array.isArray(parsed) && parsed._billing) return parsed._billing;
    if (Array.isArray(parsed) && parsed[0] && typeof parsed[0] === 'object' && parsed[0]._billing) {
      return parsed[0]._billing;
    }
  }
  return headerBillingUi || null;
}

/**
 * @param {unknown} parsed
 * @returns {unknown[]}
 */
export function extractWebhookActions(parsed) {
  const root = firstRecord(parsed);
  if (root && Array.isArray(root.actions)) return root.actions;
  return [];
}
